import { Checkout } from './shopify-frontend-api/src/index';

export const verifyDiscount = async code => {
  console.log('Calculating discount');
  // Apply and verify a discount
  await Checkout.applyDiscount(code);
  await Checkout.verifyDiscount(code);
};
